import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GMapsSuggestionInput } from '../components/delivery/location/location.component';
import { GET_LOCATION_PREDICTIONS } from '../queries/googleMap-queries';

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  // private apiKey = "AIzaSyAmSVtmLyt8KiIQj0uwelMzUhqgz3anCQA"; // Replace with your actual API key
  constructor(private apollo: Apollo) {}

  getAutocompleteResults(input: GMapsSuggestionInput) {
    return this.apollo.watchQuery({
      query: GET_LOCATION_PREDICTIONS,
      variables: {
        gMapsInput: input,
      },
    }).valueChanges;
  }
}
